import request from "@/utils/request";

export async function getQuoteRuleResults(pricingEngineResultId) {
  const params = {
    pricingEngineResultId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quote-rule-results`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function getPricingEngineResultByQuoteIds(quoteIds) {
  const params = {
    quoteIds,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/engine-result/by-quote-ids`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function getPricingEngineResultByShipmentVin(shipmentId, vin) {
  const params = {
    shipmentId,
    vin,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/engine-result/by-shipment-vin`, {
    method: "GET",
    params,
  });

  return result.data;
}

export async function runPricingEngine(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/engine`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function createQuickQuoteDealer(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quick-quotes`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function createQuickQuoteAdmin(data) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quick-quotes/admin`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getPendingQuickQuotesCount() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quick-quotes/pending/count`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getDealerQuickQuotesCount() {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quick-quotes/count`, {
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}

export async function getBDMQuickQuotesCount(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/pricing-service/quick-quotes/admin/count`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result.data;
}
